import { useMemo } from 'react';

import { useOrderContext } from 'modules/order/common/providers/OrderProvider';

import { useFormContext, useField } from '../../../forms/orderForm';
import { calculateBusinessDays } from '../../../helpers';

export const useExecutionPeriodSection = () => {
  const { values } = useFormContext();

  const { disabledDates, minEndDate, brokerTimezoneOffset } = useOrderContext();

  const { helpers: executionPeriodInBusinessDaysHelpers } = useField(
    'executionPeriodInBusinessDays'
  );

  const enabledYears = useMemo(
    () => new Set(disabledDates.map((date) => date.getFullYear())),
    [disabledDates]
  );

  const changeExecutionPeriodInBusinessDays = (
    startDate: Date | null,
    endDate: Date | null
  ) => {
    if (endDate && startDate) {
      const executionPeriodInBusinessDays = calculateBusinessDays(
        startDate,
        endDate,
        disabledDates
      );

      executionPeriodInBusinessDaysHelpers.setValue(
        executionPeriodInBusinessDays
      );
    } else {
      executionPeriodInBusinessDaysHelpers.setValue(undefined);
    }
  };

  const onChangeEndDate = (endDate: Date | null) => {
    changeExecutionPeriodInBusinessDays(values.startDate ?? null, endDate);
  };

  const onChangeStartDate = (startDate: Date | null) => {
    changeExecutionPeriodInBusinessDays(startDate, values.endDate ?? null);
  };

  return {
    enabledYears,
    disabledDates,
    minEndDate,
    brokerTimezoneOffset,
    onChangeEndDate,
    onChangeStartDate,
  };
};
